import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import './style.css';
import CircularProgress from '@mui/material/CircularProgress';
import Offer from './Offer'

const Offers = ({ direction, loading, noData, offers }) => (
    <>
        {
            loading ?
                
                <TableRow>
                    <TableCell colSpan="4">
                        <CircularProgress />
                    </TableCell> 
                </TableRow> :
                null
        }
        { offers?.map( ( offer, index ) => ( <Offer key={ 'offer-' + index } { ...offer } direction={ direction } /> ) ) }
        {
            !offers || offers.length === 0 ?
                <TableRow sx={{ '& td': { border: 0 } } }>
                    <TableCell align='center' colSpan="4">
                        { noData }
                    </TableCell> 
                </TableRow> :
                null
        }
    </>
);

Offers.propTypes = {
    direction: PropTypes.string,
    loading: PropTypes.bool,
    noData: PropTypes.string,
    offers: PropTypes.array,
}

export default Offers;